import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type CustomExpenseType = {
  name: string
  categoryId: number
  expenseTypeId: number
}

export const customExpenseType = (name: string, categoryId: number, relationId: string): Promise<CustomExpenseType> => {
  return adminHttpClient.post('/Expenses/AddCustomExpenseType', {
    name: name,
    categoryId: categoryId,
    relationId: relationId,
  })
}

export const editCustomExpenseType = (
  name: string,
  categoryId: number,
  expenseTypeId?: number,
): Promise<CustomExpenseType> => {
  return adminHttpClient.post('/Expenses/AddCustomExpenseType', {
    name: name,
    categoryId: categoryId,
    expenseTypeId: expenseTypeId,
  })
}

export const deleteCustomExpenseType = (productClassId: string, expenseTypeId: number): Promise<any> => {
  return adminHttpClient.delete('/Expenses/DeleteCustomExpenseType', {
    data: {
      expenseTypeId: expenseTypeId,
      productClassId: productClassId,
    },
  })
}
